import { Link } from 'react-router-dom';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { type RecentActivityItem } from 'xosign-types';
import buildCopy from './buildCopy.util';
import styles from './RecentActivity.module.scss';

interface RowProps {
  item: RecentActivityItem;
  dayjsLocale: string;
  t: (key: string, opts?: Record<string, unknown>) => string;
}

const Row = ({ item, dayjsLocale, t }: RowProps) => {
  const copy = buildCopy(item, t);
  if (!copy) {
    return null;
  }
  // Per-instance .locale() so the React Compiler picks up locale changes —
  // see the same pattern in AwaitingSignatures/Row.tsx.
  const timeAgo = dayjs(item.occurredAt).locale(dayjsLocale).fromNow();

  return (
    <li>
      <Link
        to={`/signings/${item.signing.id}/report/summary`}
        className={styles.row}
      >
        <span
          className={classNames(styles.iconWrap, styles[`tone_${copy.tone}`])}
          aria-hidden="true"
        >
          {copy.icon}
        </span>
        <div className={styles.meta}>
          <div className={styles.text}>{copy.text}</div>
          <div className={styles.time}>{timeAgo}</div>
        </div>
      </Link>
    </li>
  );
};

export default Row;
